import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Title, Description, MultiCard } from "@/ui";

export default function MultiCards({ sectionId, className, bgColor, title, titleColor, description, items }) {
  return (
    <div id={sectionId} className={clsx(className, bgColor)}>
      <Container className="mw-xl">
        <Title className={titleColor} title={title} />
        <Description description={description} />
        <Row className="g-3 g-md-5 pt-3">
          {items.map(({ title, img, href }, k) => (
            <Col key={k} xs={6} sm={4} md={3}>
              <MultiCard title={title} img={img?.url} href={href} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
